import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddSearchTermService {
  private subject = new Subject<string>();

  get newTerm(): Observable<string> {
    return this.subject.asObservable();
  }

  pushTerm(term: string): void {
    this.subject.next(term);
  }
}
